<template>
  <v-dialog v-model="show" :max-width="width" persistent>
    <v-card>
      <v-card-title class="text-h6">
        <v-icon v-if="icon" left :color="color">{{ icon }}</v-icon>
        {{ title }}
      </v-card-title>
      <v-card-text class="pt-2" v-html="message"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">{{ cancelText }}</v-btn>
        <v-btn :color="color" dark @click="confirm">{{ confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      title: "Confirm",
      message: "",
      confirmText: "Yes",
      cancelText: "No",
      color: "primary",
      icon: "",
      width: 420,
      resolve: null,
    };
  },
  methods: {
    open(options = {}) {
      this.title = options.title || "Confirm";
      this.message = options.message || "";
      this.confirmText = options.confirmText || "Yes";
      this.cancelText = options.cancelText || "No";
      this.color = options.color || "primary";
      this.icon = options.icon || "";
      this.width = options.width || 420;
      this.show = true;
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    confirm() {
      this.show = false;
      if (this.resolve) this.resolve(true);
    },
    cancel() {
      this.show = false;
      if (this.resolve) this.resolve(false);
    },
  },
};
</script>
